/**
 * Utilidades para manejo de fechas
 * Funciones compartidas para formateo y parseo de fechas
 */

/**
 * Parsea un string de fecha "YYYY-MM-DD" a objeto Date
 * @param {string|Date} dateString - String de fecha o objeto Date
 * @returns {Date|null} Objeto Date o null si no es válido
 */
export const parseLocalDate = (dateString) => {
  if (!dateString) return null;
  if (dateString instanceof Date) return dateString;
  const parts = dateString.split("-");
  if (parts.length !== 3) return null;
  const year = parseInt(parts[0], 10);
  const month = parseInt(parts[1], 10) - 1;
  const day = parseInt(parts[2], 10);
  return new Date(year, month, day);
};

/**
 * Convierte fecha de formato YYYY-MM-DD a dd/mm/aaaa
 * @param {string} dateString - Fecha en formato YYYY-MM-DD
 * @returns {string} Fecha en formato dd/mm/aaaa
 */
export const formatToDisplayDate = (dateString) => {
  if (!dateString) return "";
  const parts = dateString.split("-");
  if (parts.length !== 3) return "";
  return `${parts[2]}/${parts[1]}/${parts[0]}`;
};

/**
 * Convierte fecha de formato dd/mm/aaaa a YYYY-MM-DD
 * @param {string} displayDate - Fecha en formato dd/mm/aaaa
 * @returns {string} Fecha en formato YYYY-MM-DD
 */
export const formatToInternalDate = (displayDate) => {
  if (!displayDate) return "";
  const parts = displayDate.split("/");
  if (parts.length !== 3) return "";
  return `${parts[2]}-${parts[1]}-${parts[0]}`;
};

/**
 * Valida que una fecha en formato dd/mm/aaaa sea válida
 * @param {string} dateString - Fecha en formato dd/mm/aaaa
 * @returns {boolean} true si es válida, false si no
 */
export const isValidDisplayDate = (dateString) => {
  if (!dateString) return false;

  const regex = /^(\d{2})\/(\d{2})\/(\d{4})$/;
  const match = dateString.match(regex);

  if (!match) return false;

  const day = parseInt(match[1], 10);
  const month = parseInt(match[2], 10);
  const year = parseInt(match[3], 10);

  if (month < 1 || month > 12) return false;
  if (day < 1 || day > 31) return false;
  if (year < 1900 || year > 2100) return false;

  const date = new Date(year, month - 1, day);

  return (
    date.getDate() === day &&
    date.getMonth() === month - 1 &&
    date.getFullYear() === year
  );
};
